import { render, staticRenderFns } from "./columnChart.vue?vue&type=template&id=71c3caa6&scoped=true&lang=pug"
import script from "./columnChart.vue?vue&type=script&lang=js"
export * from "./columnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3caa6",
  null
  
)

export default component.exports